<div *ngIf="searchResults?.hasSucceeded && !searchResults?.isLoading && searchResults?.payload?.page.length > 0" @fadeIn>
  <ds-viewable-collection
    [config]="searchConfig.pagination"
    [hasBorder]="hasBorder"
    [sortConfig]="searchConfig.sort"
    [objects]="searchResults"
    [hideGear]="true"
    [context]="context"
    (contentChange)="contentChange.emit()">
  </ds-viewable-collection>
</div>
<ds-loading *ngIf="isLoading()" message="{{'loading.mydspace-results' | translate}}"></ds-loading>
<ds-error *ngIf="searchResults?.hasFailed && (!searchResults?.errorMessage || searchResults?.statusCode != 400)" message="{{'error.search-results' | translate}}"></ds-error>
<h3 *ngIf="searchResults?.payload?.page.length == 0" class="text-center text-muted" ><span>{{'mydspace.results.no-results' | translate}}</span></h3>
